import {SystemActionTypes, SystemState, UPDATE_SYSTEM} from './types';

export function updateSystem(newSystem: SystemState): SystemActionTypes {
  return {
    type: UPDATE_SYSTEM,
    payload: newSystem
  };
}
